import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) return <BootSplash />;
  if (user === false)
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to="/" replace />;
  return children;
}

function BootSplash() {
  return (
    <div
      data-testid="boot-splash"
      className="flex h-screen items-center justify-center bg-background"
    >
      <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">
        Booting Service OS
      </div>
    </div>
  );
}
